let qwest = require('qwest');
let EmailPreferences = require('../models/emailPreferences.jsx');

let onSuccess = () => {
  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

module.exports = {
  validateEmailToken(token) {
    return qwest.post('api/CustPrefs/getEmail' , null, {
      headers: {
        Authorization: token,
      },
    })
    .then(onSuccess(), onError);
  },

  getPreferences(email, caslApproved = null) {
    return qwest.post(`api/CustPrefs/GetPreferences`, {
      email: email,
      casl: caslApproved,
    })
    .then(onSuccess(), onError);
  },

  getAccountInfo(email) {
    return qwest.post('api/CustPrefs/GetAccountInfo', {
      email: email,
    })
    .then(onSuccess(), onError);
  },

  saveCustomerEmailPreferences(preferences) {
    if (typeof preferences.toApiFormat !== 'function') {
      return undefined;
      // Error occurred
    }

    var prefs = preferences.toApiFormat();

    return qwest.post('api/CustPrefs/SaveCustomerEmailPreferences', prefs).then((xhr, response) => {
      if (response.success) {
        let prefs = EmailPreferences.fromApiFormat(response.data);

        return prefs;
      }
      throw response;
    });
  },
};
